import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MyHttpClient } from '../http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var PaymentTransactionsService = /** @class */ (function () {
    function PaymentTransactionsService(http) {
        this.http = http;
        this.server = environment.server;
        this.getPaymentTransactionsURL = this.server + '/api/redeem/paymentTransactions';
    }
    PaymentTransactionsService.prototype.handleError = function (error) {
        return throwError(error);
    };
    PaymentTransactionsService.prototype.getPaymentTransactions = function (orderId, captainId) {
        var url = this.getPaymentTransactionsURL + "/" + orderId;
        var body = { captainId: captainId };
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    PaymentTransactionsService.ngInjectableDef = i0.defineInjectable({ factory: function PaymentTransactionsService_Factory() { return new PaymentTransactionsService(i0.inject(i1.MyHttpClient)); }, token: PaymentTransactionsService, providedIn: "root" });
    return PaymentTransactionsService;
}());
export { PaymentTransactionsService };
